export default "__VITE_ASSET__kuxmFtge__"